/************************************
GOOGLE MAPS
************************************/

jQuery(function ($) {
    let gmgeocoder = null;

    // Initialize geocoder when Google Maps API is ready
    if (typeof google !== 'undefined' && typeof google.maps.Geocoder !== 'undefined') {
        gmgeocoder = new google.maps.Geocoder();
    }

    // Restrict Autocomplete to South Africa (ZA)
    const initSearchBox = (inputElementId) => {
        const input = document.getElementById(inputElementId);
        if (!input) {
            console.error(`Input element with ID "${inputElementId}" not found.`);
            return null;
        }

        const autocomplete = new google.maps.places.Autocomplete(input, {
            componentRestrictions: { country: 'ZA' },
            fields: ['address_components', 'geometry', 'formatted_address'],
            types: ['address']
        });

        return autocomplete;
    };

    // Make GoogleSearchAddressChanged globally accessible
    window.GoogleSearchAddressChanged = function (searchBoxElement, autocomplete) {
        const place = autocomplete.getPlace();
        searchBoxElement = $(searchBoxElement);

        if (!place || !place.geometry) {
            return { error: 'No address found. Please select from the suggestions.' };
        }

        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();

        if (!latitude || !longitude) {
            return { error: "Please ensure you select an address with valid coordinates." };
        }

        let streetAddress = "";
        let streetNumber = "";
        const city = [];
        const suburb = [];
        let venueName = "";
        let postalCode = "";

        if (searchBoxElement.val().includes(",")) {
            venueName = searchBoxElement.val().substring(0, searchBoxElement.val().indexOf(","));
        }

        const formattedAddress = place.formatted_address;

        for (const comp of place.address_components) {
            for (const type of comp.types) {
                if (type === "street_number") {
                    streetNumber = comp.long_name;
                } else if (type === "route") {
                    streetAddress = comp.long_name;
                } else if (["sublocality", "sublocality_level_1", "sublocality_level_2"].includes(type)) {
                    suburb.push(comp.long_name);
                } else if (["locality", "administrative_area_level_3"].includes(type)) {
                    city.push(comp.long_name);
                    if (type === "locality" && suburb.length === 0) {
                        suburb.push(comp.long_name);
                    }
                } else if (type === "postal_code") {
                    postalCode = comp.long_name;
                }
            }
        }

        if (`${streetNumber} ${streetAddress}`.trim() === venueName) {
            venueName = "";
        }

        if (streetAddress === "") {
            streetAddress = venueName;
        }

        return {
            FormattedAddress: formattedAddress,
            StreetNum: streetNumber,
            StreetName: streetAddress,
            City: city.length > 0 ? city[0] : "",
            Suburb: suburb.length > 0 ? suburb[0] : "",
            Lat: latitude,
            Lng: longitude,
            VenueName: venueName,
            PostalCode: postalCode,
            googleMapsResult: place.address_components,
            error: null
        };
    };

    // Optional: expose for external use
    window.InitSouthAfricaSearchBox = initSearchBox;
});
